<template>
<PageShell>
  <h1 class="site-h1">About Us</h1>
  <p class="site-lead">Welcome to <strong>GBAppWhats</strong>, an independent website dedicated to providing helpful information about GB WhatsApp. Our goal is to make it easier for Android users to find the latest version, understand its features, and learn how to install and update the app safely.</p>
  <p>We publish easy-to-follow guides, download information, version updates, troubleshooting articles, and feature comparisons. Whether you're looking for the latest GB WhatsApp APK, an older version, or answers to common installation issues, our content is designed to help.</p>

  <h2 class="site-h2">Our Mission</h2>
  <p>Our mission is to create a reliable resource for users interested in GB WhatsApp. We focus on writing clear, accurate, and practical content that helps visitors understand the app before downloading or updating it.</p>

  <h2 class="site-h2">What We Publish</h2>
  <p>GBAppWhats regularly updates content covering:</p>
  <ul class="site-ul">
    <li>GB WhatsApp APK downloads</li>
    <li>Latest version updates</li>
    <li>Old version archives</li>
    <li>Installation tutorials</li>
    <li>Update guides</li>
    <li>Feature explanations</li>
    <li>Frequently asked questions</li>
    <li>Troubleshooting articles</li>
  </ul>

  <h2 class="site-h2">Our Content Standards</h2>
  <p>Every article is reviewed before publication and updated whenever a new version becomes available. We aim to keep our information accurate, easy to read, and relevant for Android users.</p>
  <p>Although we strive for accuracy, app features and compatibility may change over time. If you notice outdated information, we welcome your feedback.</p>

  <h2 class="site-h2">Independent Website</h2>
  <p>GBAppWhats is an independent website and is <strong>not affiliated with, endorsed by, or sponsored by Meta Platforms, Inc. or WhatsApp LLC</strong>. GB WhatsApp is a third-party modified application created by independent developers.</p>
  <p>All trademarks, logos, and brand names belong to their respective owners.</p>

  <h2 class="site-h2">Contact Us</h2>
  <p>If you have suggestions, notice incorrect information, or would like to contact our team, please visit our <router-link to="/contact/">Contact page</router-link>. We appreciate feedback that helps us improve our website and provide a better experience for our visitors.</p>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'

export default {
  name: 'About',
  components: { PageShell },
}
</script>
